// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"371":"23c0fbae","867":"bf13a2d7","998":"cc7c0b6b"}[chunkId] + ".chunk.css";
};